var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4697 17.5303C16.7626 17.8232 17.2374 17.8232 17.5303 17.5303C17.8232 17.2374 17.8232 16.7626 17.5303 16.4697L16.4697 17.5303ZM13.4265 7.58824C13.4265 10.8126 10.8126 13.4265 7.58824 13.4265V14.9265C11.641 14.9265 14.9265 11.641 14.9265 7.58824H13.4265ZM7.58824 13.4265C4.36387 13.4265 1.75 10.8126 1.75 7.58824H0.25C0.25 11.641 3.53544 14.9265 7.58824 14.9265V13.4265ZM1.75 7.58824C1.75 4.36387 4.36387 1.75 7.58824 1.75V0.25C3.53544 0.25 0.25 3.53544 0.25 7.58824H1.75ZM7.58824 1.75C10.8126 1.75 13.4265 4.36387 13.4265 7.58824H14.9265C14.9265 3.53544 11.641 0.25 7.58824 0.25V1.75ZM11.7638 12.8244L16.4697 17.5303L17.5303 16.4697L12.8244 11.7638L11.7638 12.8244Z",
    fill: "#D9DCE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.3b824cef8a37a0b9e875075bf0dc6b06.svg";
export { ForwardRef as ReactComponent };